<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* 全局隐藏 el-table 滚动条 */
.el-table__body-wrapper::-webkit-scrollbar,
.el-table__fixed-body-wrapper::-webkit-scrollbar {
  display: none !important;
}

.el-table__body-wrapper,
.el-table__fixed-body-wrapper {
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}
</style>